/* istanbul ignore file */
import React from 'react';
import { EditButton } from 'framework/ui/ui-builder';
import { useEmployeeOfferUrl } from 'domain/people/employee/offers/employeeOfferRouting';

const EditEmployeeOfferButton = ({ ...props }) => {
  const { getUpdateEntityUrl } = useEmployeeOfferUrl();

  return <EditButton path={getUpdateEntityUrl} {...props} />;
};

export default EditEmployeeOfferButton;
